type FloatingInputProps = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  error?: boolean;
  type?: string;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  autoComplete?: string;
  className?: string;
  limitLength?: boolean;
};

export const FloatingInput = ({
  label,
  value,
  onChange,
  inputRef,
  error,
  type = "text",
  inputMode,
  autoComplete,
  limitLength,
  className,
}: FloatingInputProps) => {
  return (
    <div className={["w-full", className].join(" ")}>
      <div
        className={[
          "relative h-[72px] rounded-[9px] border-[1.23px] bg-white px-[16px]",
          "focus-within:border-[#0079FF]",
          error ? "border-[#FF3B30] focus-within:border-[#FF3B30]" : "border-[#C1C7CD]",
        ].join(" ")}
      >
        <input
          maxLength={limitLength ? 20 : undefined}
          ref={inputRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          type={type}
          inputMode={inputMode}
          autoComplete={autoComplete}
          placeholder=" "
          className="
            peer h-full w-full bg-transparent border-none outline-none
            pt-[22px]
            text-[16px] leading-6 text-[#121319]
            placeholder:text-transparent
          "
        />

        <label
          className="
            pointer-events-none absolute left-[14px]
            text-[#4D4F58]
            transition-all duration-200 ease-out

            top-1/2 -translate-y-1/2 text-[16px]

            /* 포커스/입력 시: 너무 위로 안 붙게 top 값을 '조금 아래'로 */
            peer-focus:top-[14px] peer-focus:translate-y-0 peer-focus:text-[12px]
            peer-[:not(:placeholder-shown)]:top-[14px]
            peer-[:not(:placeholder-shown)]:translate-y-0
            peer-[:not(:placeholder-shown)]:text-[12px]
          "
        >
          {label}
        </label>
      </div>
    </div>
  );
};
